import { useMemo, useState, useEffect } from 'react'
import { SearchConfigProps } from 'components/WorkspaceDashboardSearchBar/Types'

interface Props {
  allSearchResults: any
  searchConfiguration: SearchConfigProps
}

export const FILES_PER_PAGE = 8

export const useSearchList = ({ allSearchResults, searchConfiguration }: Props) => {
  const [loaded, setLoaded] = useState(false)

  const filesResults = useMemo(
    () => allSearchResults && searchConfiguration && allSearchResults[searchConfiguration.indexId],
    [allSearchResults, searchConfiguration],
  )
  const hasResults = useMemo(() => filesResults?.hits?.length > 0, [filesResults])

  useEffect(() => {
    if (loaded) return
    if (!!filesResults) setLoaded(true)
  }, [filesResults, loaded])

  return {
    hasResults,
    loaded,
  }
}
